<template lang="html">
  <div class="contenitore">
    <div class="riga">
      <div class="colonna-1">
        <div class="testo">
          <p>PI IT02548800305</p>
          <p>Tel. 0432 634145</p>
          <a href="https://www.iubenda.com/privacy-policy/17684678" class="iubenda-white iubenda-noiframe iubenda-embed iubenda-noiframe " title="Privacy Policy ">Privacy & Cookie Policy</a>
        </div>
      </div>
      <div class="colonna-2">
        <div class="logo">
          <a href="https://repalnet.eu">
            <img src="https://repalnet.eu/wp-content/uploads/2020/06/logo-repalnet-bianco.png">
          </a>
        </div>
      </div>
      <div class="colonna-3">
        <div class="voci">
          <div class="riga-voci">
            <div class="colonna-voci">
              <a href="https://repalnet.eu/chi-siamo">Chi Siamo</a>
            </div>
            <div class="colonna-voci">
              <a href="https://repalnet.eu/servizi">Servizi</a>
            </div>
            <div class="colonna-voci">
              <a href="https://repalnet.eu/contatti">Contatti</a>
            </div>
            <div class="colonna-voci">
              <a href="https://repalnet.eu/faq">Faq</a>
            </div>
            <div class="colonna-voci">
              <a href="https://repalnet.eu/news">News</a>
            </div>
          </div>
          <div class="riga-icone">
            <div class="colonna-icone">
              <div class="social">
                <img src="https://repalnet.eu/wp-content/uploads/2020/06/linkedin-icon.png">
              </div>
            </div>
            <div class="colonna-icone">
              <div class="social">
                <img src="https://repalnet.eu/wp-content/uploads/2020/06/facebook-icon.png">
              </div>
            </div>
            <div class="colonna-icone">
              <div class="social">
                <img src="https://repalnet.eu/wp-content/uploads/2020/06/instagram-icon.png">
              </div>
            </div>
            <div class="colonna-icone">
              <div class="social">
                <img src="https://repalnet.eu/wp-content/uploads/2020/06/youtube-icon.png">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



<script type="text/javascript">(function (w,d) {var loader = function () {var s = d.createElement("script"), tag = d.getElementsByTagName("script")[0]; s.src="https://cdn.iubenda.com/iubenda.js"; tag.parentNode.insertBefore(s,tag);}; if(w.addEventListener){w.addEventListener("load", loader, false);}else if(w.attachEvent){w.attachEvent("onload", loader);}else{w.onload = loader;}})(window, document);</script>

<script>
export default {
}
</script>

<style lang="css" scoped>
.contenitore{
  background-color: black;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  /* position:inherit; */
  bottom:0;
  width:100%;
}
.riga{
  padding-top: 30px;
  padding-bottom: 30px;
  display: flex;
  flex-direction: row;
  padding-left: 10px;
  padding-right: 10px;
}
.testo{
  font-size: 14px;
  color: white;
}
.logo{
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.logo img{
  width: 55%;
  height: auto;
}
.colonna-1{
  width: 80%;
}
.colonna-2{
  width: 80%;
}
.colonna-3{
  width: 80%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.social img{
  max-height: 30px;
}
.riga-voci{
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding-bottom: 20px;
}
.riga-voci a{
  color: white;
}
.riga-icone{
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.colonna-voci{
  padding-left: 24px;
  color: white;
}
.colonna-icone{
  padding-left: 7px;
}
@media only screen and ( max-width: 1278px ) {
  .colonna-voci{
    padding-left: 12px;
  }
}
@media only screen and ( max-width: 1053px ) {
  .colonna-voci{
    padding-left: 8px;
  }
}
@media only screen and (max-width: 980px) {
  .riga{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}
@media only screen and (max-width: 980px) {
  .colonna-1{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 30px;
  }
  .testo{
    text-align: center;
  }
}
@media only screen and (max-width: 980px) {
  .colonna-2{
    width: 40%;
    margin-bottom: 30px;
  }
}
@media only screen and (max-width: 980px) {
  .colonna-3{
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-bottom: 30px;
  }
}
@media only screen and (max-width: 980px) {
  .riga-icone{
    justify-content: center;
  }
}
</style>
